// extracted by mini-css-extract-plugin
export var actionButton = "_ej-0";
export var attachmentLine = "_ej-1";
export var fileInput = "_ej-2";
export var fileUploadWrapper = "_ej-4";
export var footer = "_ej-3";
export var modalContent = "_ej-5";
export var paperclip = "_ej-6";
export var quillEditor = "_ej-7";